import { render } from "./CreateReport.vue?vue&type=template&id=a006e3b8&ts=true"
import script from "./CreateReport.vue?vue&type=script&lang=ts"
export * from "./CreateReport.vue?vue&type=script&lang=ts"

import "./CreateReport.vue?vue&type=style&index=0&id=a006e3b8&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__